<template>
  <!-- <div> -->
  <v-toolbar-items class="d-none d-md-flex d-md-none pa-0 ma-0">
    <v-menu right bottom offset-y v-if="toolbarMenu.setup">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text small>
          Setup
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="setUp('GEN', 'General Setup')" v-if="toolbarMenu.general">
          <v-list-item-title>General</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('PI', 'Personal Information')" v-if="toolbarMenu.personalInfo">
          <v-list-item-title>Personal Information</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('EI', 'Employment Information')" v-if="toolbarMenu.employmentInfo">
          <v-list-item-title>Employment Information</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('EOI', 'Employment Other Information')" v-if="toolbarMenu.employmentOtherInfo">
          <v-list-item-title>Employment Other Information</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu right bottom :offset-y="true" v-if="toolbarMenu.maintenance">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text small>
          Maintenance
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="setUp('EMF', 'Employee Master File')" v-if="toolbarMenu.empMasterfile">
          <v-list-item-title>Employee Master File</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('EOIM', 'Employee Other Information')" v-if="toolbarMenu.empOtherInfo">
          <v-list-item-title>Employee Other Information</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <v-btn text @click="setUp('MAINT', 'Maintenance')">Maintenance</v-btn> -->

    <v-menu right bottom :offset-y="true" v-if="toolbarMenu.transaction">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text small>
          Transactions
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="setUp('PMT', 'Personnel Movement')" v-if="toolbarMenu.personnelMovement">
          <v-list-item-title>Personnel Movement</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('MPT', 'Manpower Pool')" v-if="toolbarMenu.manpowerPool">
          <v-list-item-title>Manpower Pool</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('PRT', 'Personnel Requisition')" v-if="toolbarMenu.pr">
          <v-list-item-title>Personnel Requisition</v-list-item-title>
        </v-list-item>
        <v-list-item @click="setUp('ECT', 'Employee Clearance')" v-if="toolbarMenu.ec">
          <v-list-item-title>Employee Clearance</v-list-item-title>
        </v-list-item>
        <v-list-item to="/schedule-of-medical-examination" v-if="toolbarMenu.schedMedExam">
          <v-list-item-title>Schedule of Medical Examination</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn text @click="setUp('UTILS', 'Utilities')" v-if="toolbarMenu.utilities" small>Utilities</v-btn>
    <v-btn text to="/reports" v-if="toolbarMenu.reports" small>Reports</v-btn>
    <!-- <v-btn text @click="setUp('REP', 'Reports')">Reports</v-btn> -->
    <v-btn text @click="admin" v-if="toolbarMenu.admin" small>Admin</v-btn>


     <v-btn text @click="onboarding" v-if="toolbarMenu.onboarding" small>Onboarding</v-btn>
     <!-- <v-menu right bottom :offset-y="true" v-if="toolbarMenu.onboarding">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text small>
          Onboarding
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item to="/onboarding-plan-setup" v-if="toolbarMenu.onboardingPlanSetup">
          <v-list-item-title>Onboarding Plan Setup'</v-list-item-title>
        </v-list-item>
        <v-list-item to="/onboarding-plan-setup-employee" v-if="toolbarMenu.onboardingPlanSetupEmp">
          <v-list-item-title>Onboarding Plan Setup per Employee</v-list-item-title>
        </v-list-item>
        <v-list-item to="/onboarding-plan-setup-completion" v-if="toolbarMenu.onboardingPlanSetupComp">
          <v-list-item-title>Onboarding Plan Setup Completion</v-list-item-title>
        </v-list-item>
        <v-list-item to="/onboarding-plan-approval" v-if="toolbarMenu.onboardingPlanApp">
          <v-list-item-title>Onboaring Plan Completion Approval</v-list-item-title>
        </v-list-item>
        <v-list-item to="/onboarding-plan-status" v-if="toolbarMenu.onboardingPlanStatus">
          <v-list-item-title>Onboarding Plan Status View</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->
    <slot></slot>
    <!-- Small Screen -->
  </v-toolbar-items>

  <!-- </div> -->
</template>
<script>
import { mapActions, mapState } from "vuex";
import AdminMenuItems from "../utils/adminMenu";
import OnboardingMenuItems from "../utils/onboardingMenu";
import routingMixin from "../mixins/routingMixin"

export default {
  mixins: [routingMixin],
  data: () => ({
    adminMenuItems: AdminMenuItems,
    onboardingMenuItems: OnboardingMenuItems
  }),
  computed: {
    ...mapState("company", {
      companyInfo: state => state.companyInfo
    })
  },
  methods: {
    ...mapActions("appRouting", ["changeRoute", "openDrawer"]),
    admin() {
      this.changeRoute(this.adminMenuItems);
      this.openDrawer(true);
    },
    setUp(value, name) {
      this.changeRoute({ routeName: name, routeValue: value });
      this.openDrawer(true);
    },
    onboarding() {
      this.changeRoute(this.onboardingMenuItems);
      this.openDrawer(true);
    },
  }
};
</script>